import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const hubWebsitesQuery = (companyId: string, gameId: string) =>
  queryOptions({
    queryKey: [gameId, 'hub', 'websites'],
    queryFn: () => dashboardClient.v1.getWebsites({ companyId, gameId }).then(r => r.data),
  })
